import {
  DEFAULT_THEME,
  THEME_STORAGE_KEY,
  isAppTheme,
  type AppTheme,
} from "@/constants/theme";
import { browserStorage } from "@/utils/browserStorage";

export function readInitialThemePreference(): AppTheme {
  const stored = browserStorage.get(THEME_STORAGE_KEY);
  return isAppTheme(stored) ? stored : DEFAULT_THEME;
}

export function applyThemePreference(theme: AppTheme): void {
  document.documentElement.classList.toggle("dark", theme === "dark");
}

export function syncThemePreference(theme: AppTheme): void {
  applyThemePreference(theme);
  browserStorage.set(THEME_STORAGE_KEY, theme);
}
